import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner
} from '../../config/react'
import DataTable from 'react-data-table-component'

const ContentManagement = () => {
  const [CmsList, setCmsList] = useState([])
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [SearchTerm, setSearchTerm] = useState('')
  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()
  const columns = [
    {
      name: 'Title',
      sortable: true,
      sortField: 'title',
      selector: (row) => row.title,
      wrap: true
    },
    // {
    //   name: 'Page Code',
    //   selector: (row) => row.page_code
    // },
    {
      name: 'Slug',
      selector: (row) => row.slug,
      wrap: true
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>,
      wrap: true
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/contentManagement/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteContentManagement(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]
  useEffect(() => {
    setIsAuth(true)
    document.title = Title.ContentManagement
    GetContentManagementList()
  }, [CustomFilters, SearchTerm])

  const GetContentManagementList = () => {
    const passParams = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetContentManagementAdminList, passParams).then((response) => {
      // setCmsList(response.data.result)
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[1]
        setCmsList(data)
        settotalRows(response.data.result[0][0].total_pages)
        setForceUpdate(!isForceUpdate)
      }
    })
  }

  const DeleteContentManagement = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true
        }
        // console.log(param);
        setLoading(true)
        HttpService.postApi(API.DeleteContentManagement, param).then((response) => {
          setLoading(false)
          // console.log(response);
          toast.success(Messages.RecordDeleted)
          GetContentManagementList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
    console.log('LN 120 Page 1' + ' &page_size ' + e)
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Title, Page Code, Slug."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })

  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.ContentManagement} </h3>
        <div className="btn-group">
          <Link
            to="/contentManagement/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.AddContentManagement}{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  columns={columns}
                  data={CmsList}
                  pagination
                  persistTableHead={true}
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentManagement
